var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96.5 97.4375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 97.4375,
    opacity: 0,
    width: 96.5,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 39.75C0 61.6875 17.8125 79.4375 39.75 79.4375C48.1875 79.4375 55.9375 76.8125 62.375 72.3125L85.625 95.625C86.9375 96.875 88.5625 97.4375 90.25 97.4375C93.875 97.4375 96.5 94.6875 96.5 91.0625C96.5 89.3125 95.8125 87.75 94.75 86.5625L71.625 63.375C76.5625 56.75 79.4375 48.625 79.4375 39.75C79.4375 17.8125 61.6875 0 39.75 0C17.8125 0 0 17.8125 0 39.75ZM9.625 39.75C9.625 23.0625 23.0625 9.625 39.75 9.625C56.375 9.625 69.875 23.0625 69.875 39.75C69.875 56.375 56.375 69.875 39.75 69.875C23.0625 69.875 9.625 56.375 9.625 39.75Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingglass);
export default __webpack_public_path__ + "static/media/magnifyingglass.ee7206988c8494f93609beca10fdd1f1.svg";
export { ForwardRef as ReactComponent };